import React from 'react';

function Preloader() {
  return (
    <div className="progress">
      <div className="indeterminate"></div>
    </div>
  );
}

export default Preloader;
